<template>
    <div class="job-row-card col-12" v-on:click="show()" v-on:mouseenter="hover = true" v-on:mouseleave="hover = false">
        <div class="job-row-card--container">
            <div class="job-row-card--container-left">
                <div class="job-row-card--info">
                    <div class="job-row-card--info-top">
                        <h3 class="job-row-card--info-top-title">{{job.name}}</h3>
                        <div class="badge badge--sm badge--primary">{{job.site.client.name}}</div>
                    </div>
                    <div class="job-row-card--info-middle">
                        <svg-image class="job-row-card--info-middle-icon" :src="'/svg/' + resource_group + '/pin.svg'" color="black" highlight="primary"></svg-image>
                        <h6 class="job-row-card--info-middle-location">
                            {{job.site.address}}, {{startDateHasPassed ? 'started on ' + job.start_date_formatted : 'starting on ' + job.start_date_formatted}}
                        </h6>
                    </div>
                    <div class="job-row-card--info-bottom">
                        <div class="badge badge--sm" v-on:mouseenter="hoverList = !user.id" v-on:mouseleave="hoverList = false" v-on:click="listClick" v-for="user in jobUsersCompiled">
                            {{user.id ? user.full_name : '+ ' + user.remaining.length + ' More'}}

                            <ul v-show="hoverList" v-if="!user.id" class="job-row-card--remaining-list">
                                <li class="job-row-card--remaining-list-item" v-for="remaining_user in user.remaining">{{remaining_user.full_name}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="job-row-card--container-left-badges">
                    <div class="badge badge--positive">{{job.upcoming + ' Form' + (job.upcoming === 1 ? '' : 's') + ' upcoming'}}</div>
                    <div class="badge badge--negative">{{job.issues + ' Form' + (job.issues === 1 ? '' : 's') + ' to resolve'}}</div>
                </div>
            </div>
            <div class="job-row-card--container-right">
                <svg-image class="job-row-card--button" color="light-grey" highlight="primary" :hover="hover" :src="'/svg/' + resource_group + '/chevron-right.svg'"></svg-image>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "JobRowCard",
        props: [
        	'job',
            'show_url'
        ],

        data() {
		    return {
                hover: false,
                hoverList: false
            }
        },

        methods: {
            listClick(e){
                e.preventDefault();
                e.stopPropagation();
            },
            setUrl(){
                this.show_url = this.show_url.replace('0', this.job.id);
            },
			show(){
                this.setUrl();
				window.location.href = this.show_url;
            }
        },

        computed: {
		    startDateHasPassed(){
		        const parsed_date_string = this.job.start_date_formatted.replace('th', '').replace('nd', '').replace('rd', '');
                return Date.parse(new Date()) > Date.parse(parsed_date_string);
            },

            jobUsersCompiled(){
		        const users = Object.assign([], this.job.users);
                let users_list = [];

                users.forEach((user) => {
                    if (users_list.length > 2){
                        users_list[2].remaining.push(user);
                    }
                    else if (users_list.length === 2){
                        users_list.push({
                            remaining: [user]
                        });
                    }
                    else {
                        users_list.push(user);
                    }
                });

                return users_list;
            }
        }
	}
</script>
